module.exports = __webpack_public_path__ + "img/region-north-america.e7c6bca8.png";